import type { CustomOfferFormValues } from '@/typings/formValues';

import { CRUISE_ITEM_TYPE, CRUISE_POST_PURCHASE_TYPE_REFARE, PURCHASE_TYPE_POST_PURCHASE } from '../../constants';
import type { PurchaseType } from '../../constants';

export type CruisePayloadParts = {
  offerFields: Pick<App.CustomOffer, 'purchase_type' | 'post_purchase_type' | 'sent_to_ati_ticketing'>;
  paymentMetadata: Pick<
    App.CustomOfferPaymentMetadata,
    | 'cruiseline_fee'
    | 'cruiseline_additional_charges'
    | 'le_fee'
    | 'refare_new_fare'
    | 'refare_new_tax_and_surcharges'
    | 'refare_deposit_fee_already_paid'
  >;
};

export const buildCruisePayload = (
  item: CustomOfferFormValues['item'],
  paymentMetadata: CustomOfferFormValues['payment_metadata'],
  purchaseType: PurchaseType,
  sentToAtiTicketing: boolean,
  postPurchaseType?: string,
): CruisePayloadParts | null => {
  if (item.type !== CRUISE_ITEM_TYPE) {
    return null;
  }

  return {
    offerFields: {
      purchase_type: purchaseType,
      post_purchase_type: purchaseType === PURCHASE_TYPE_POST_PURCHASE ? postPurchaseType : undefined,
      sent_to_ati_ticketing: purchaseType === PURCHASE_TYPE_POST_PURCHASE ? sentToAtiTicketing : false,
    },
    paymentMetadata: {
      cruiseline_fee: Math.round((paymentMetadata.cruiseline_fee ?? 0) * 100),
      cruiseline_additional_charges: Math.round((paymentMetadata.cruiseline_additional_charges ?? 0) * 100),
      le_fee: Math.round((paymentMetadata.le_fee ?? 0) * 100),
      ...(postPurchaseType === CRUISE_POST_PURCHASE_TYPE_REFARE && {
        refare_new_fare: Math.round((paymentMetadata.refare_new_fare ?? 0) * 100),
        refare_new_tax_and_surcharges: Math.round((paymentMetadata.refare_new_tax_and_surcharges ?? 0) * 100),
        refare_deposit_fee_already_paid: Math.round((paymentMetadata.refare_deposit_fee_already_paid ?? 0) * 100),
      }),
    },
  };
};
